<template>
<div class="container" style="margin-top: 40px;">
    <div class="row">
        <div class="col-md-2">
        </div>

        <div class="col-md-8" style="margin-bottom:20px;">
            <strong>
                <a href="/db">
                    Content Analysis Database
                </a>
                >
                Useful Fields for Content Analysis</strong>
            <h1>Useful
                <span :style="'padding:3px 10px;background-color:'+filter_type.color+';color:'+filter_type.text_color" v-if="filter_type">{{filter_type.title}}</span>
                Fields for <br />Content Inventories, Audits, & other Analysis
            </h1>

            <div v-if="filter_type" style="margin:20px;padding:20px;background-color:white;">
                <h2>Field Type: {{filter_type.title}}</h2>
                <div style="font-size:larger;" v-html="filter_type.content"></div>
                See {{filter_type.title}} fields below. Or <a href="/db/fields">show all field types.</a>
            </div>

    <p>
        If we take the traditional view of a content inventory or audit, we have rows
        representing each page (so each row has a unique URL) and then we have columns
        for things like the meta description or crawl depth. These columns are the different
        <strong>fields</strong> we have available to us in our content analysis.
    </p>
    <div style="margin-bottom:15px;padding:10px;border: 1px black solid;background-color:#eee">
    <span><img style="float:left;margin-right:20px;" src="/images/fields/np_stop-sign_250586_000000.png" width="42px;" />
        How to conduct a content inventory, audit, or other analysis depends on
    size and complexity.
        <el-switch
            v-model="is_complex"
            active-text="Complex"
            inactive-text="Focused">
        </el-switch></span>

    </div>
    <div v-if="is_complex" >
        <p>
            Some fields
            have more value than others in content analysis (the content analysis value is the
            y axis) and some are more amenable to automation (the x axis).
        </p>
        <div class="large-scatter">
            <ChartScatter
                @dotClicked="dotClicked($event)"
                height="250" width="800"
                :chartData="points_filtered"
                :render_info="{
                  display_extra: false,
                  background_color_scale: 0
                }"
            />
        </div>
        <div class="medium-scatter">
            <ChartScatter
                @dotClicked="dotClicked($event)"
                height="250" width="400"
                :chartData="points_filtered"
                :render_info="{
                  display_extra: false,
                  background_color_scale: 0
                }"
            />
        </div>
        <span>
        Why is ease of automation important? It boils down to four things: 1) allowing you to see
        the breadth across a large digital presence, 2) allowing you to <strong>iterate</strong>
        your analysis, 3) efficiency, and 4) consistency. Can automation do everything? No.
    </span>
    </div>
    </div>
    </div>
    <div class="row">
        <div class="col-md-2">

        </div>
        <div class="col-md-8">
            <div>
                Show:
                <el-checkbox v-model="pop_1">★</el-checkbox>
                <el-checkbox v-model="pop_2">★★</el-checkbox>
                <el-checkbox v-model="pop_3">★★★</el-checkbox>
                <el-checkbox v-model="show_basic">Basic Fields</el-checkbox>
            </div>
            <div>
                Take action:
                <a href>Download CSV</a> ·
                <a href>Save and Share</a> ·
                <a>Initiate Crawl in Chimera</a>
            </div>
            <div>
                Jump to:
                <el-select v-model="value" placeholder="Select">
                    <el-option
                        v-for="item in approaches"
                        :key="item.slug"
                        :label="item.title"
                        :value="item.slug">
                    </el-option>
                </el-select>
            </div>

        </div>
    </div>
    <div class="row" v-for="row in rows_filtered" style="margin-bottom:20px;">
        <div class="col-md-4" v-for="col in row">
            <el-card class="box-card" :style="'margin:8px;background-color:'+(col.category_slug==='basic'?'#EFF4FA':'white')">
                <div slot="header" class="clearfix">
                    <a :href="'/db/fields/'+col.slug">
                        <span>{{col.label}}</span>
                    </a>
                    <span v-for="index in col.popularity">★</span>
                    ♡

                    <el-button
                        :style="'float: right; padding: 3px;background-color:'+col.color+';color:'+col.text_color" type="text"
                        @click="goCategory(col.category_slug)"
                    >{{col.category}}</el-button>
                </div>
                {{col.content}}
            </el-card>
        </div>

    </div>

</div>
</template>

<script>
export default {
    name: "ListFieldsCA",
    props: ['fields','filter_type','approaches'],
    data() {
        return {
            is_complex: true,
            pop_1: false,
            pop_2: false,
            pop_3: true,
            show_basic: true,
        }
    },
    computed: {
        fields_filtered: function () {
            if (this.fields) {
                return this.fields.filter(field => {
                    if (!this.show_basic && field.field_type_pretty.slug==='basic') return false;
                    let tentative = false;
                    if (this.pop_1 && field.popularity === 1) tentative = true;
                    if (this.pop_2 && field.popularity === 2) tentative = true;
                    if (this.pop_3 && field.popularity === 3) tentative = true;
                    if (tentative && this.filter_type) {
                        if (field.field_type_pretty.slug === this.filter_type.slug) return true;
                        else return false;
                    }
                    return tentative;
                })
            }


        },
        points_filtered: function () {

            let points = []
            this.fields_filtered.forEach(field => {
                let point = {
                    'x': field.automation_ease + Math.random() * 0.25 - 0.125,
                    'y': field.analysis_value  + Math.random() * 0.1 - 0.05,
                    'x_actual': field.automation_ease,
                    'y_actual': field.analysis_value,
                    'label': field.title,
                    'slug': field.slug,
                    'overlaps': field.field_type_pretty.slug === 'basic' ? true : false,
                    'category': field.field_type_pretty.label,
                    'category_actual': field.field_type_pretty.label,
                    'color': field.field_type_pretty.color,
                    'text_color': field.field_type_pretty.text_color,
                    'style': field.field_type_pretty.slug === 'basic' ? 'hollow' : 'solid',
                };
                points.push(point)
            })
            return {
                'data': points,
                'meta': {
                    'min_x': 0.5,
                    'min_y': 0.5,
                    'max_x': 10.5,
                    'max_y': 10.5,
                    'label': 'Useful Field',
                    'color_by_field': '',
                    'x': 'Ease of Automation',
                    'y': 'Value in Content Analysis'
                }
            }
        },
        rows_filtered: function () {
            let row = []
            let rows = []
            let max_cols = 3
            let curr_col = 0

            this.fields_filtered.forEach(field => {
                curr_col++
                if (curr_col>max_cols) {
                    rows.push(row)
                    row = []
                    curr_col = 1
                }
                let cell = {
                    'label': field.title,
                    'slug': field.slug,
                    'content': field.content,
                    'color': field.field_type_pretty.color,
                    'text_color': field.field_type_pretty.text_color,
                    'category': field.field_type_pretty.label,
                    'category_slug': field.field_type_pretty.slug,
                    'popularity': field.popularity,
                }
                row.push(cell)
            })
            if (row) rows.push(row)
            return rows
        },
    },
    mounted() {
        if (this.filter_type) {
            this.pop_1 = true
            this.pop_2 = true
            this.pop_3 = true
        }
    },
    methods: {
        dotClicked(event) {
            console.log(event.slug)
            window.location.href= "/db/fields/" + event.slug
        },
        goCategory(slug) {
            window.location.href= "/db/fields?filter_type="+slug
        },
    },
}
</script>

<style scoped>

</style>